import { Helpers } from '../../helpers';
import { IScheduleActivityStatus } from '../../interfaces/ischedule-activity-status';
import { ScheduleActivity } from '../schedule-activity';

export class ScheduleActivityStatusBase {
  ScheduleActivityStatusId: number;
  ScheduleActivityStatusCode: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  P6Status: string | null;

  ScheduleActivities_ScheduleActivityStatusCode?: Array<ScheduleActivity> | null;

  constructor(item?: IScheduleActivityStatus) {
    if (item) {

      this.ScheduleActivityStatusId = item.ScheduleActivityStatusId;
      this.ScheduleActivityStatusCode = item.ScheduleActivityStatusCode;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.P6Status = item.P6Status;

      this.ScheduleActivities_ScheduleActivityStatusCode = Helpers.createClassArray(ScheduleActivity, item.ScheduleActivities_ScheduleActivityStatusCode);
    }
  }
}